import axios from 'axios';

export const UPDATE = 'nzTitles/actions/UPDATE';

export const initialState = {
  disclaimers: {},
  titles: [],
};

const NzTitlesDuck = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE:
      return action.payload;
    default:
      return state;
  }
};

export default NzTitlesDuck;

export function fetchNzTitles(propertyId) {
  return async (dispatch) => {
    try {
      const response = await axios.get(`/api/properties/${propertyId}/titles`);
      if (response?.data) {
        dispatch(updateNzTitles({
          data: response.data,
        }));
      }
    } catch (e) {
      console.log('failed to fetch nz titles');
    }
  };
}

export function updateNzTitles({data}) {
  return {
    type: UPDATE,
    payload: data,
  };
}
